<template>
  <div>
    <wc-data-box
      :title='details.title'
      :titleIcon='details.icon'
      :titleIconColor='details.iconColor'
      :showEdit='!project.archived'
      @edit='editDetails'
    >
      <wc-two-column-table :items='items'></wc-two-column-table>
      <v-card-text class='py-0 mb-n2'>
        <span class='grey--text py-0'><i>(Head count Formula: 2 X bigs + smalls)</i></span> 
      </v-card-text>
      <v-card-text class='pt-0'>
        {{ project.project_detail.lawn_signs_note }}
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='details.title'
      :icon='details.icon'
      :iconColor='details.iconColor'
      @cancel='showDialog = false'
      @save='saveEdit'
      width='400'
    >
      <v-form v-model='isFormValid'>
        <irrigation-details-form v-model='projectCopy'></irrigation-details-form>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import IrrigationDetailsForm from '@/modules/irrigation/components/forms/IrrigationDetailsForm'

export default {
  name: 'irrigation-project-details',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showDialog: false,
    projectCopy: {}
  }),
  computed: {
    items () {
      let tmp = [{ text: 'Site Type', value: this.project.is_comm ? 'Commercial' : 'Residential' }]
      if (!this.project.project_detail.is_capital_system) {
        tmp.push({ text: 'Takeover date', value: this.project.project_detail.install_date ? this.$options.filters.shortDate(this.project.project_detail.install_date) : 'Not set' })
      } else {
        tmp.push({ text: 'Install date', value: this.project.project_detail.install_date ? this.$options.filters.shortDate(this.project.project_detail.install_date) : 'Not set' })
      }
      if (this.project.is_comm) {
        tmp.push({ text: 'Meter Pit?', value: this.$options.filters.trueFalse(this.project.project_detail.has_meter_pit) })
      }
       tmp.push({ text: 'Hose bib supply?', value: this.$options.filters.trueFalse(this.project.project_detail.is_hose_bib) })
       tmp.push({ text: 'Rain sensor installed?', value: this.$options.filters.trueFalse(this.project.install_form && this.project.install_form.labelled_rain_sensor_location) })
       tmp.push({ text: 'Charged line to hose bib?', value: this.$options.filters.trueFalse(this.project.project_detail.has_charged_hose_bib) })
       tmp.push({ text: 'Charged line to water feature?', value: this.$options.filters.trueFalse(this.project.project_detail.has_charged_feature) })
       tmp.push({ text: 'Number of Zones', value: this.project.project_detail.num_zones })
       tmp.push({ text: 'Number of Heads', value: this.project.project_detail.num_heads })
      return tmp
    },
    ...mapState ({
      details: state => state.icons.dataBox.details
    })
  },
  methods: {
    editDetails () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      this.$emit('update', this.projectCopy)
      this.cancelEdit()
    }
  },
  components: {
    'irrigation-details-form': IrrigationDetailsForm
  }
}
</script>
